import React, { useState } from "react";
import { CalendarSvg } from "../../../svgFiles/CalendarSvg";
import { OverlayTrigger, Popover } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LeftChevronSvg } from "../../../svgFiles/LeftChevronSvg";
import { RightChevronSvg } from "../../../svgFiles/RightChevronSvg";
import Button from "../buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment-timezone";
import { getAppTz } from "../../../helpers/Utils";

const getAppToday = () => {
  const tz = getAppTz();
  return moment.tz(tz).format("YYYY-MM-DD");
};

const toPickerDate = (appDate) => {
  const [year, month, day] = appDate.split("-").map(Number);
  // Noon avoids edge cases around DST transitions at midnight.
  return new Date(year, month - 1, day, 12, 0, 0, 0);
};

const toAppDateString = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

const formatDate = (appDate) => {
  return moment(appDate, "YYYY-MM-DD").format("DD-MM-YYYY");
};

const DateSelector = ({ setDate }) => {
  const [selectedAppDate, setSelectedAppDate] = useState(getAppToday);
  const [showCalendar, setShowCalendar] = useState(false);
  const formattedDate = formatDate(selectedAppDate);
  const todayAppDate = getAppToday();
  const selectedDate = toPickerDate(selectedAppDate);
  const today = toPickerDate(todayAppDate);
  const { _t } = useTranslator();

  const isToday = selectedAppDate === todayAppDate;

  const handleDateChange = (date) => {
    if (date) {
      const appDate = toAppDateString(date);
      setSelectedAppDate(appDate);
      setDate(appDate);
      setShowCalendar(false);
    }
  };

  const handleLeft = () => {
    const previousDay = moment(selectedAppDate, "YYYY-MM-DD")
      .subtract(1, "day")
      .format("YYYY-MM-DD");
    setSelectedAppDate(previousDay);
    setDate(previousDay);
  };

  const handleRight = () => {
    const nextDay = moment(selectedAppDate, "YYYY-MM-DD")
      .add(1, "day")
      .format("YYYY-MM-DD");
    if (nextDay > todayAppDate) {
      return;
    }
    setSelectedAppDate(nextDay);
    setDate(nextDay);
  };


  const popover = (
    <Popover id="calendar-popover">
      <Popover.Body>
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          inline
          maxDate={today}
        />
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      <div>
        <div className="d-flex gap-2 align-items-center">
          <Button
            className="noTitleBtn"
            icon={LeftChevronSvg}
            onClick={handleLeft}
          />

          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            rootClose
            show={showCalendar}
            onToggle={(isOpen) => setShowCalendar(isOpen)}
          >
            <div>
              <div
                className="dateFilterField borderRedBtn cmn_btn btn-small d-flex gap-2 align-items-center"
                onClick={() => setShowCalendar(!showCalendar)}
              >
                {CalendarSvg}
                <span> {_t("date", "Date")}: {formattedDate}</span>
              </div>
            </div>
          </OverlayTrigger>

          <Button
            className="noTitleBtn"
            icon={RightChevronSvg}
            onClick={handleRight}
            disabled={isToday}
          />
        </div>
      </div>
    </>
  );
};

export default DateSelector;
